import { render, staticRenderFns } from "./allocate-audit-modal.vue?vue&type=template&id=24cb6a96&"
import script from "./allocate-audit-modal.vue?vue&type=script&lang=js&"
export * from "./allocate-audit-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports